<template>
    <div class="myDivToPrint">
        <div class="modal-header align-items-center">
            <h3 class="modal-title">
                {{ $t("pos.x-atchot") }} ( {{ $t("pos.x-nachalo") }} :
                {{ currentReport.startDate }} - {{ $t("pos.x-kones") }} :
                {{ currentReport.endDate }})
            </h3>
            <div class="d-flex align-items-center hide-print">
                <b-link @click="print">
                    <i class="fa fa-print editBtn"/>
                </b-link>
                <button type="button" @click="close" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-sm-12">
                    <div class="modal-body box-z-report">
                        <template v-if="currentReport.totalWithoutDiscount != 0">
                            <table class="table table-striped table-bordered">
                                <tbody>
									<tr>
										<th>{{ $t("xAtchot.title") }}</th>
										<th></th>
									</tr>
									<tr v-for="(payment, index) in currentReport.payments" :key="`cash-payment-${index}`">
										<td v-if="payment.name!=='UZCARD'&&payment.name!=='HUMO'">
											<span v-if="payment.name === 'NAQD'"><span class="flag-icon flag-icon-uz" style="font-size: 1.4rem"/> Naqd</span>
											<span v-else-if="payment.name === 'QARZGA'"><img src="@/assets/balance.png" alt="balance" style="width: 1.5rem"/> Qarzga</span>
											<span v-else-if="payment.name === 'QARZGA_USD'"><img src="@/assets/balance.png" alt="balance" style="width: 1.5rem"/> Qarzga</span>
                                            <span v-else-if="payment.name === 'USD'"> <span class="flag-icon flag-icon-us" style="font-size: 1.4rem"></span> USD</span>
											<span v-else>{{ payment.name }}</span>
										</td>
										<td v-if="payment.name!=='UZCARD'&&payment.name!=='HUMO'">
											<span>{{ payment.value | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</span>
										</td>
									</tr>
                                    <tr v-if="depCurrencyCode!=='USD'">
                                        <th>{{ $t("xAtchot.cart") }}</th>
										<th></th>
                                    </tr>
                                    <tr v-for="(payment, index) in currentReport.payments" :key="`card-payment-${index}`">
                                        <td v-if="payment.name==='UZCARD'||payment.name==='HUMO'">
                                            <span v-if="payment.name === 'UZCARD'">
                                                <img :src="`${publicPath}img/pos-images/uzcard.png`" alt="UzCard" style="width: 2.5rem"/> Uzcard
                                            </span>
                                            <span v-else-if="payment.name === 'HUMO'">
                                                <img :src="`${publicPath}img/pos-images/humo_card.png`" alt="HumoCard" style="width: 2.5rem"/> Humo
                                            </span>
                                        </td>
                                        <td v-if="payment.name==='UZCARD'||payment.name==='HUMO'">
											<span>{{ payment.value | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</span>
										</td>
                                    </tr>
									<tr>
										<th class="text-right">Всего</th>
										<th>{{currentReport.proceeds | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '})}}</th>
									</tr>
									<tr>
										<th class="text-center" colspan="2">Продажи</th>
									</tr>
									<tr class="success">
                                        <th>Количество чеков продаж</th>
                                        <td><b>{{ currentReport.saleQty }}</b></td>
                                    </tr>
									<tr class="success">
                                        <th>Наличные</th>
                                        <td><b>{{ currentReport.saleCash | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
                                    </tr>
									<tr class="success">
                                        <th>В долгу</th>
                                        <td><b>{{ currentReport.saleQarzga | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
                                    </tr>
									<tr v-if="depCurrencyCode!=='USD'" class="success">
                                        <th>Банковские карты</th>
                                        <td><b>{{ currentReport.saleCard | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
                                    </tr>
									<tr>
										<th class="text-center" colspan="2">Возвраты</th>
									</tr>
                                    <tr class="success">
                                        <th>Количество чеков возврата</th>
                                        <td><b>{{ currentReport.saleReturnQty }}</b></td>
                                    </tr>
                                    <tr class="success">
                                        <th>Наличные</th>
                                        <td><b>{{ currentReport.saleReturnCash | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
                                    </tr>
									<tr class="success">
										<th>В долгу</th>
										<td><b>{{ currentReport.saleReturnQarzga | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
									</tr>
                                    <tr v-if="depCurrencyCode!=='USD'" class="success">
                                        <th>Банковские карты</th>
                                        <td><b>{{ currentReport.saleReturnCard | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
                                    </tr>
									<tr>
										<th class="text-center" colspan="2">Итого</th>
									</tr>
									<tr class="success">
										<th>Выручка</th>
										<td><b>{{ currentReport.proceeds | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
									</tr>
									<tr class="success">
										<th>Наличные</th>
										<td><b>{{ currentReport.proceedsCash | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
									</tr>
									<tr class="success">
										<th>В долгу</th>
										<td><b>{{ currentReport.proceedsQarzga | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
									</tr>
									<tr v-if="depCurrencyCode!=='USD'" class="success">
										<th>Банковские карты</th>
										<td><b>{{ currentReport.proceedsCard | currency({symbol: depCurrencyCode, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b></td>
									</tr>
                                </tbody>
                            </table>
                        </template>
                        <template v-else>
                            <b-alert variant="info" show>Продажи еще не сделаны</b-alert>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer justify-content-start">
            <h4>
                <b>{{ $t("xAtchot.cashier") }}:</b>
                {{ currentReport.cashierFullName }}
                <br/>
            </h4>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { TokenService } from "@/services/storage.service";
import FBoxService from "@/services/fbox.service";
export default {
    name: "XAndZReport",
    props: {
        zReportId: {
            type: Number,
            default: null,
        },
        depId: {
            type: Number,
            default: null,
        },
        isZReport: {
            type: Boolean,
            default: false,
        },
		isFromZReportsPage: {
            type: Boolean,
            default: false,
        },
    },
	data(){
    	return{
			lastCurrencyRates: [],
		}
	},
    async created () {
        if (this.isZReport && !this.isFromZReportsPage) {
            if (this.zReportId) {
                await this.getZReportById({zReportId: this.zReportId, depId: this.depId,});
            } else await this.getCurrentZReport(localStorage.getItem('dep_id'));

        } else if (!this.isFromZReportsPage) await this.getCurrentXReport(localStorage.getItem('dep_id'));
    },
    computed: {
        ...mapState(["userDepCurrencyName"]),
        ...mapState("zetReport", ["currentReport"]),
        ...mapState("pos", {
            cashier: "cashierFullName",
        }),
		depCurrencyCode () {
			return localStorage.getItem('dep_currency_code')
		},
        publicPath () {
            return process.env.BASE_URL;
        },
        cashAmounts () {
            return this.currentReport && this.currentReport.payments
                ? this.currentReport.payments["CASH"]
                    ? this.currentReport.payments["CASH"]
                    : {}
                : {};
        },
        bankCardAmounts () {
            return this.currentReport && this.currentReport.payments
                ? this.currentReport.payments["BANK_CARD"]
                    ? this.currentReport.payments["BANK_CARD"]
                    : {}
                : {};
        },
    },

    methods: {
        ...mapActions("zetReport", [
            "getCurrentXReport",
            "getCurrentZReport",
            "getZReportById",
        ]),
        close () {
            this.$emit("close");
        },
		async print() {
			window.print()
		},
        async printReport () {
            let resFromFBox = null;
            let errMsgFromFBox = null;
            try {
                resFromFBox = await FBoxService.xAndZReportCloseOrPrint({
                    ipAddress: localStorage.getItem('ip_address'),
                    data: this.currentReport.payments,
                    closeZReport: false,
                    salesEur: this.currentReport.salesEuro,
                    totalEur: this.currentReport.totalWithDiscount - this.currentReport.totalRefundAmount,
                });
            } catch (e) {
                if (e.request && e.request.response) {
                    let response = JSON.parse(e.request.response);
                    errMsgFromFBox = response.message;
                }
            }

			if (!resFromFBox || !resFromFBox.data.is_success) {
				let fbError = resFromFBox ? resFromFBox.data.error.message : (errMsgFromFBox ? errMsgFromFBox : 'XATOLIK: Iltimos, qayta urunib ko\'ring')
                this.$vs.notify({
                    title: fbError,
                    color: 'danger',
                    icon: 'close',
                    position: 'top-right'
                });
			}
        },
    },
};
</script>

<style scoped>
@media print {
	.myDivToPrint {
		background-color: white;
		height: 100%;
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		margin: 0;
		padding: 15px;
		font-size: 14px;
		line-height: 18px;
	}
	.hide-print {
		display: none;
	}
}
</style>

<style lang="scss">
.box-z-report {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
    padding: 10px;

    table {
        td,
        th {
            font-size: 0.9rem;
            padding: 0.4rem;
        }
    }
}
</style>
